export const DIGITS = [...'1234567890'];
export const DEFAULT_DECIMAL_SEPARATOR = '.';
export const DEFAULT_THOUSANDS_SEPARATOR = '';
export const DEFAULT_ALLOWED_DECIMAL_SEPARATORS = ['.', ',']; // should be non-digit charactes of length 1
export const DEFAULT_ALLOWED_THOUSANDS_SEPARATORS = ['', '.', ',']; // can be any strings

export const DEFAULT_ANIMATION_DELAY = 200;
export const MAX_ANIMATION_DELAY = 6_000;
export const ANIMATION_DELAY_SLIDER_STEP = 200;

export const DEFAULT_TIME_BASED_ANIMATION_DURATION = 2_000;
export const MIN_ANIMATION_DURATION = 200;
export const MAX_ANIMATION_DURATION = 6_000;
export const ANIMATION_DURATION_SLIDER_STEP = 200;

export const DEFAULT_SPRING_FRICTION = 26;
export const MIN_SPRING_FRICTION = 10;
export const MAX_SPRING_FRICTION = 140;
export const SPRING_FRICTION_SLIDER_STEP = 2;

export const DEFAULT_SPRING_TENSION = 170;
export const MIN_SPRING_TENSION = 100;
export const MAX_SPRING_TENSION = 300;
export const SPRING_TENSION_SLIDER_STEP = 10;

export const ALLOWED_TAG_NAMES = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'div',
  'span',
  'sup',
  'sub',
  'del',
  'code',
  'blockquote',
  'button',
] as const; // subset of (keyof ReactHTML)
export const TEXT_ALIGNS = ['left', 'right', 'center', 'justify'] as const;
export const DECIMAL_SEPARATORS_FOR_NUMBER_DETECTION = ['.', ','] as const;
export const SPECIAL_DELIMITER = '|'; // to join detected numbers, should not be in `DECIMAL_SEPARATORS_FOR_NUMBER_DETECTION`
export const COLOR_PALETTE = [
  { name: 'Black', color: '#000000' },
  { name: 'Cyan bluish gray', color: '#abb8c3' },
  { name: 'White', color: '#ffffff' },
  { name: 'Pale pink', color: '#f78da7' },
  { name: 'Vivid red', color: '#cf2e2e' },
  { name: 'Luminous vivid orange', color: '#ff6900' },
  { name: 'Luminous vivid amber', color: '#fcb900' },
  { name: 'Light green cyan', color: '#7bdcb5' },
  { name: 'Vivid green cyan', color: '#00d084' },
  { name: 'Pale cyan blue', color: '#8ed1fc' },
  { name: 'Vivid cyan blue', color: '#0693e3' },
  { name: 'Vivid purple', color: '#9b51e0' },
] as const;
export const SYMBOL_NAME = {
  '': 'None',
  ' ': 'Space',
  '.': 'Period',
  ',': 'Comma',
  '\t': 'Tab',
  '  ': 'Double spaces',
  '    ': 'Four spaces',
} as const;
export const DEFAULT_PLACEHOLDER = 'Insert text';
